<template>
  <div id="chart-line-item-item-box">
    <chart-title leftTitle="TPM设备动态监测 left_11"></chart-title>
    <div class="left_11_card">
      <date-change-card
        height="70%"
        @leftClick="leftClick"
        @rightClick="rightClick"
      >
      <div id="left_11" slot="main"></div>
      </date-change-card>
      <div class="steps">
        <div
          :class="`steps_item ${step == 1 ? ' steps_active' : ''}`"
          @click="changeStep(1)"
        >
          <div class="step__head">
            <div class="step__line">
              <i class="step__line-inner"></i>
            </div>
            <div class="step__icon">
              <div class="step__icon-inner">1</div>
            </div>
          </div>
          <div class="step__main">
            <div class="step__title">雕刻机</div>
          </div>
        </div>
        <div
          :class="`steps_item ${step == 2 ? ' steps_active' : ''}`"
          @click="changeStep(2)"
        >
          <div class="step__head">
            <div class="step__line">
              <i class="step__line-inner"></i>
            </div>
            <div class="step__icon">
              <div class="step__icon-inner">2</div>
            </div>
          </div>
          <div class="step__main">
            <div class="step__title">封边机</div>
          </div>
        </div>
        <div
          :class="`steps_item ${step == 3 ? ' steps_active' : ''}`"
          @click="changeStep(3)"
        >
          <div class="step__head">
            <div class="step__line">
              <i class="step__line-inner"></i>
            </div>
            <div class="step__icon">
              <div class="step__icon-inner">3</div>
            </div>
          </div>
          <div class="step__main">
            <div class="step__title">六面钻</div>
          </div>
        </div>
        <div
          :class="`steps_item ${step == 4 ? ' steps_active' : ''}`"
          @click="changeStep(4)"
        >
          <div class="step__head">
            <div class="step__icon">
              <div class="step__icon-inner">4</div>
            </div>
          </div>
          <div class="step__main">
            <div class="step__title">电子锯</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import resize from "@/utils/resize";
import ChartTitle from "../../../components/chartTitle";
import DateChangeCard from "../../../components/dateChangeCard";
export default {
  mixins: [resize],
  name: "left_11",
  components: { ChartTitle,DateChangeCard },
  data() {
    return {
      chart: null,
      step: 1,
    };
  },
  props: {},
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },

  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    changeStep(val) {
      this.step = val;
    },
    initChart() {
      this.chart = this.$echarts.init(document.getElementById("left_11"));
      this.setOptions();
    },
    setOptions() {
      let data = [];
      for (let i = 1; i <= 31; i++) {
        data.push(i);
      }
      this.chart.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          data: ["正常运行", "维修"],
          textStyle: {
            color: "#C0C4CC",
            fontSize: "10",
          },
          bottom: "5%",
        },
        grid: {
          left: "11%",
          right: "11%",
          bottom: "15%",
          top: "15%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: data,
            axisLabel: {
              color: "#606266",
              fontSize: "10",
            },
            axisLine: {
              lineStyle: {
                color: "#606266",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              color: "#606266",
              fontSize: "10",
            },
            axisLine: {
              lineStyle: {
                color: "#606266",
              },
            },
            splitLine: {
            lineStyle: {
              color: "#606266",
              type: "dashed", //设置网格线类型 dotted：虚线 solid:实线
            },
          },
          },
        ],
        series: [
          {
            name: "正常运行",
            type: "line",
            smooth: true,
            areaStyle: {opacity: 0.3},
            data: [
              120, 132, 101, 134, 230, 240, 230, 120, 132, 101, 100, 90, 230,
              210, 120, 132, 101, 134, 90, 230, 210, 120, 132, 101, 134, 90,
              230, 210, 120, 132, 101, 134, 90, 230, 210,
            ],
            color: "#29beb9",
          },
          {
            name: "维修",
            type: "line",
            smooth: true,
            areaStyle: {opacity: 0.3},
            data: [
              220, 182, 191, 234, 290, 330, 310, 220, 182, 191, 234, 290, 330,
              310, 220, 182, 191, 234, 290, 330, 310, 220, 182, 191, 234, 290,
              330, 310, 220, 182, 191, 234, 290, 330, 310,
            ],
            color: "#1c7ce8",
          },
          {
            // 设置涟漪特效动画
            type: "effectScatter",
            coordinateSystem: "cartesian2d",
            data: [['13',330],['20',230]],
            symbolSize: 9,
            // 何时显示特效:'render'-绘制完成后显示特效 'emphasis'-高亮（hover）的时候显示特效
            showEffectOn: "render",
            // 涟漪特效配置
            rippleEffect: {
              // 波纹的绘制方式,可选'stroke'和'fill'
              brushType: "stroke",
            },
            hoverAnimation: true,
            itemStyle: {
              normal: {
                color: "rgba(255,255,255,0.9)",
                shadowBlur: 38,
                shadowColor: "rgba(255,255,255,0.9)",
              },
            },
            zlevel: 1,
            tooltip: {
              show: false,
            },
          },
        ],
      });
    },
     //前一月
    leftClick() {
      console.log("leftClick");
    },
    //后一月
    rightClick() {
      console.log("rightClick");
    },
  },
};
</script>

<style lang="scss" scoped>
#chart-line-item-item-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 50vh;
  .left_11_card {
    height: calc(100% - 30px);
    #left_11 {
      height: 100%;
      margin-bottom: 20px;
    }
    .steps {
      margin-top:14px;
      display: flex;
      .steps_item {
        cursor: pointer;
        display: inline-block;
        flex-basis: 25%;
        margin-right: 0px;
        max-width: 25%;
        .step__head {
          color: #409eff;
          border-color: #409eff;
          text-align: center;
          position: relative;
          width: 100%;
          .step__line {
            left: 50%;
            right: -50%;
            height: 2px;
            top: 11px;
            position: absolute;
            .step__line-inner {
              border-width: 1px;
              width: 100%;
              display: block;
              border-style: solid;
              color: #409eff;
            }
          }
          .step__icon {
            border-radius: 50%;
            border: 2px solid;
            border-color: inherit;
            position: relative;
            z-index: 1;
            display: inline-flex;
            -webkit-box-align: center;
            align-items: center;
            justify-content: center;
            width: 24px;
            height: 24px;
            font-size: 14px;
            background: #fff;
            .step__icon-inner {
              font-weight: 700;
            }
          }
        }
        .step__main {
          text-align: center;
          white-space: normal;
          .step__title {
            color: #409eff;
            font-size: 14px;
            line-height: 38px;
          }
        }
      }
      .steps_active {
        .step__head {
          color: #67c23a;
          border-color: #67c23a;
        }
        .step__main {
          .step__title {
            color: #67c23a;
          }
        }
      }
    }
  }
}
</style>
